export const filterNames = {
  status: 'status',
  query: 'query',
  page: 'page',
  orderBy: 'orderBy',
  type: 'type',
  collectedDates: 'collectedDates',
  collectedDateStart: 'collectedDateStart',
  collectedDateEnd: 'collectedDateEnd',
  invoiceDates: 'invoiceDates',
  invoiceDateStart: 'invoiceDateStart',
  invoiceDateEnd: 'invoiceDateEnd',
}

export const filters = [
  { name: 'status', type: 'array', localStorageName: 'billingStatus' },
  { name: 'query', type: 'string', backendName: 'search' },
  { name: 'page', type: 'number', defaultValue: 1 },
  { name: 'orderBy', type: 'string', defaultValue: '-created_at', backendName: 'ordering' },
  { name: 'type', type: 'string', localStorageName: 'billingType' },
  {
    name: 'collectedDateStart',
    localStorageName: 'collectedDateStart',
    type: 'string',
    backendName: 'collected_at__gte',
  },
  { name: 'collectedDateEnd', localStorageName: 'collectedDateEnd', type: 'string', backendName: 'collected_at__lte' },
  { name: 'invoiceDateStart', localStorageName: 'invoiceDateStart', type: 'string', backendName: 'created_at__gte' },
  { name: 'invoiceDateStart', localStorageName: 'invoiceDateStart', type: 'string', backendName: 'created_at__gte' },
  { name: 'invoiceDateEnd', localStorageName: 'invoiceDateEnd', type: 'string', backendName: 'created_at__lte' },
]
